import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useSportContext } from '@sorare/core/src/contexts/sport';

// Return true if Common Collections is enabled for the current sport & user
export const useEnableCommonCollections = () => {
  const { currentUser } = useCurrentUserContext();
  const { sport } = useSportContext();
  if (sport === Sport.FOOTBALL) {
    return !!currentUser?.betaTesterFootballCommonCardsGame;
  }

  // Collections are enabled for all sports except football
  return true;
};
